import { render, staticRenderFns } from "./UploadFileList.vue?vue&type=template&id=1cf04d74&scoped=true"
import script from "./UploadFileList.vue?vue&type=script&lang=js"
export * from "./UploadFileList.vue?vue&type=script&lang=js"
import style0 from "./UploadFileList.vue?vue&type=style&index=0&id=1cf04d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf04d74",
  null
  
)

export default component.exports